import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './plugins/i18n'
import vuetify from './plugins/vuetify'
import { createVueI18nAdapter } from 'vuetify/locale/adapters/vue-i18n'
import { useI18n } from 'vue-i18n';
import { loadFonts } from './plugins/webfontloader'

import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { BarChart } from 'echarts/charts';
import { LineChart } from 'echarts/charts'
import { GridComponent, TooltipComponent, TitleComponent, LegendComponent } from 'echarts/components';
import VChart from 'vue-echarts';
import eventBus from '@/utils/eventBus';
import toast from '@/utils/toast';
use([CanvasRenderer, LineChart, BarChart, GridComponent, TooltipComponent, TitleComponent, LegendComponent]);

loadFonts()

import 'vuetify/dist/vuetify.min.css';
import '@/assets/styles/main.css'
import '@/assets/styles/woocommerce.css';
vuetify.locale.adapter = createVueI18nAdapter({ i18n, useI18n })
const app = createApp(App)
app.config.globalProperties.$t = i18n.global.t;
app.config.globalProperties.$eventBus = eventBus;
app.use(vuetify)
app.use(router)
app.use(store)
app.use(i18n)
app.provide('t', i18n.global.t);
app.component('v-chart', VChart)
app.use(toast)
window.VueApp = app;
app.mount('#app')
